import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const IDLE_LIMIT_MS = 30 * 60 * 1000;
export const IDLE_MESSAGE = "You were signed out after 30 minutes of inactivity";
const SESSION_ENDED = [IDLE_MESSAGE, "Your session has ended. Please sign in again."];
export const markActivity = () => localStorage.setItem("lastActivity", String(Date.now()));
export const lastActivity = () => Number(localStorage.getItem("lastActivity")) || Date.now();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (Date.now() - lastActivity() < 60 * 1000) config.headers["X-User-Active"] = "1";
  return config;
});

api.interceptors.response.use(undefined, (error) => {
  if (error.response?.status === 401 && SESSION_ENDED.includes(error.response?.data?.detail) && localStorage.getItem("token")) {
    window.dispatchEvent(new CustomEvent("idle-logout", { detail: error.response.data.detail }));
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
